<section class="e-tax-invoice-intro">
  <div class="box">
    <div class="box-left">
      <div class="box-left__subheading"
        ><span>{{ 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_INTRO.SUBHEADING' | translate }}</span></div
      >
      <h1 class="box-left__heading"
        ><span>{{ 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_INTRO.HEADING' | translate }}</span></h1
      >
      <div class="box-left__detail"
        ><span>{{ 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_INTRO.DETAIL' | translate }}</span></div
      >
      <div class="box-left__pricing">
        <div class="box-left__pricing--text"
          ><span>{{ 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_INTRO.PRICING.TEXT' | translate }}</span></div
        >
        <div class="box-left__pricing--number">
          <div class="number-price"><span>165</span></div>
          <div class="number-bath"
            ><span>{{ 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_INTRO.PRICING.BATH' | translate }}</span></div
          >
        </div>
      </div>
      <div class="box-left__button">
        <a
          class="box-left__button--layout"
          [href]="'https://auth.flowaccount.com/' + this.translate.currentLang + '/Account/Register'"
          rel="noopener noreferrer"
          target="_blank"
          ><span>{{ 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_INTRO.BTN' | translate }}</span></a
        >
      </div>
    </div>
    <div class="box-right desktop">
      <swiper-container class="swiper" appSwiper [config]="config" init="false">
        <ng-container *ngFor="let item of duplicatedMockContent()">
          <swiper-slide class="swiper-slide">
            <a class="box-right__img" [href]="item.link" target="_blank" rel="nofollow noopener">
              <picture>
                <source [srcset]="item.imageWebp" type="image/webp" />
                <img
                  [src]="item.image"
                  class="box-right__img--layout"
                  [alt]="'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_INTRO.SUBHEADING' | translate"
                  loading="eager"
                />
              </picture>
            </a>
          </swiper-slide>
        </ng-container>
      </swiper-container>
      <div class="swiper-button-prev">
        <i class="fas fa-arrow-left"></i>
      </div>
      <div class="swiper-button-next">
        <i class="fas fa-arrow-right"></i>
      </div>
    </div>

    <div class="box-right mobile">
      <swiper-container class="swiper" appSwiper [config]="configMobile" init="false">
        <ng-container *ngFor="let item of mockContent">
          <swiper-slide class="swiper-slide">
            <a class="box-right__img" [href]="item.link" target="_blank" rel="nofollow noopener">
              <picture>
                <source [srcset]="item.imageMobileWebp" type="image/webp" />
                <img
                  [src]="item.imageMobile"
                  class="box-right__img--layout"
                  [alt]="'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_INTRO.SUBHEADING' | translate"
                  loading="eager"
                />
              </picture>
            </a>
          </swiper-slide>
        </ng-container>
      </swiper-container>
    </div>
  </div>
</section>
